export function createRequestForm({ endpoint, nonce } = {}) {
  return () => ({
    loading: false,

    form: {
      type: '',
      name: '',
      tel: '',
      message: '',
      agree: false,
    },

    endpoint: endpoint || '/wp-json/dcraft/v1/request',
    nonce: nonce || '',

    formatTel() {
      let value = String(this.form.tel || '').replace(/\D/g, '');

      // 너무 길면 잘라냄
      if (value.length > 11) value = value.slice(0, 11);

      // 02 서울번호
      if (value.startsWith('02')) {
        if (value.length <= 2) {
          this.form.tel = value;
          return;
        }

        if (value.length <= 5) {
          this.form.tel = value.replace(/(02)(\d+)/, '$1-$2');
          return;
        }

        // 02-123-4567
        if (value.length <= 9) {
          this.form.tel = value.replace(/(02)(\d{3})(\d+)/, '$1-$2-$3');
          return;
        }

        // 02-1234-5678
        this.form.tel = value.replace(/(02)(\d{4})(\d{4})/, '$1-$2-$3');
        return;
      }

      // 3자리 국번 (010, 032, 051, 070 등)
      if (value.length <= 3) {
        this.form.tel = value;
        return;
      }

      if (value.length <= 6) {
        this.form.tel = value.replace(/(\d{3})(\d+)/, '$1-$2');
        return;
      }

      // 10자리: 032-333-2770 / 031-123-4567
      if (value.length === 10) {
        this.form.tel = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        return;
      }

      // 11자리: 010-1234-5678 / 032-3333-1234
      this.form.tel = value.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    },

    notify(message, type = 'info') {
      // window.Alpine?.store('toast')?.show?.('접수되었습니다.', 'success');
      if (window.Alpine?.store('toast')) {
        window.Alpine?.store('toast')?.show?.(message, type);
        return;
      }

      window.alert(message);
    },

    validate() {
      if (!this.form.type) {
        this.notify('문의 유형을 선택해 주세요.', 'error');
        return false;
      }

      if (!this.form.name.trim()) {
        this.notify('업체명 또는 이름을 입력해 주세요.', 'error');
        return false;
      }

      if (!this.form.tel.trim()) {
        this.notify('연락처를 입력해 주세요.', 'error');
        return false;
      }

      const telOnly = this.form.tel.replace(/[^0-9]/g, '');
      if (telOnly.length < 9) {
        this.notify('연락처 형식을 확인해 주세요.', 'error');
        return false;
      }

      if (!this.form.message.trim()) {
        this.notify('문의 내용을 입력해 주세요.', 'error');
        return false;
      }

      if (!this.form.agree) {
        this.notify('개인정보처리방침 동의가 필요합니다.', 'error');
        this.$nextTick(() => this.$refs.agreeInput?.focus());
        return false;
      }

      return true;
    },

    getPayload() {
      return {
        type: this.form.type,
        name: this.form.name.trim(),
        tel: this.form.tel.trim(),
        message: this.form.message.trim(),
        agree: this.form.agree,
      };
    },

    resetForm() {
      this.form = {
        type: '',
        name: '',
        tel: '',
        message: '',
        agree: false,
      };
    },

    async submitForm() {
      if (this.loading) return;
      if (!this.validate()) return;

      this.loading = true;

      try {
        const headers = {
          'Content-Type': 'application/json',
        };

        if (this.nonce) {
          headers['X-WP-Nonce'] = this.nonce;
        }

        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers,
          body: JSON.stringify(this.getPayload()),
        });

        const text = await response.text();
        let data = null;

        try {
          data = text ? JSON.parse(text) : null;
        } catch {
          data = text;
        }

        if (!response.ok) {
          throw new Error(data?.message || '문의 접수 중 문제가 발생했습니다.');
        }

        this.notify('문의가 정상적으로 접수되었습니다.', 'success');
        this.resetForm();
      } catch (error) {
        this.notify(error?.message || '전송 중 오류가 발생했습니다.', 'error');
      } finally {
        this.loading = false;
      }
    },
  });
}
